import { Injectable } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TaskSucessDialogComponent } from "./task-action-dialogs/task-success-dialog/task-success-dialog.component";
import { DialogService } from "../shared/ui/dialog/dialog.service";
import { PollTaskRecurrenceDialogComponent } from "./task-action-dialogs/poll-task-recurrence-dialog/poll-task-recurrence-dialog.component";
import { CreateOrEditTaskLabelDialogComponent } from "./task-label/create-task-label-dialog/create-task-label-dialog.component";
import { TaskLabel } from "./taskbook.types";


@Injectable({
    providedIn: 'root'
})
export class TaskDialogService {

    constructor(private dialogService: DialogService) { }

    async taskSuccess(task): Promise<MatDialogRef<TaskSucessDialogComponent>> {
        return this.dialogService.open(TaskSucessDialogComponent, {
            minWidth: '380px',
            maxWidth: '520px',
            width: '100%',
            enterAnimationDuration: 0,
            exitAnimationDuration: 0,
            data: {
                task: task
            }
        });
    }

    async makePollRecurrent(task): Promise<MatDialogRef<PollTaskRecurrenceDialogComponent>> {
        return this.dialogService.open(PollTaskRecurrenceDialogComponent, {
            minWidth: '380px',
            maxWidth: '640px',
            width: '100%',
            enterAnimationDuration: 0,
            exitAnimationDuration: 0,
            data: {
                task: task
            }
        });
    }

    async createOrEditTaskLabel(label: TaskLabel, mode: string): Promise<MatDialogRef<CreateOrEditTaskLabelDialogComponent>> {
        return this.dialogService.open(CreateOrEditTaskLabelDialogComponent, {
            width: '380px',
            enterAnimationDuration: 0,
            exitAnimationDuration: 0,
            data: {
                label: label,
                mode: mode
            }
        });
    }

}